import { PartReservationService } from "@common/client"
import { makeNoArgsQuery, makeQuery } from "./utils"

const PART_RESERVATION_PAGE_SIZE = 500

export const partReservationsBaseKey = ["part-reservations"] as const

export const partReservationsKey = (partId: string) =>
  [...partReservationsBaseKey, "list", partId] as const

export const partReservationsQuery = makeQuery({
  serviceCall: (partId: string) =>
    PartReservationService.listReservations({
      part_id: partId,
      limit: PART_RESERVATION_PAGE_SIZE,
    }),
  queryKey: partReservationsKey,
})

export const holdingWorkOrdersQuery = makeNoArgsQuery({
  serviceCall: PartReservationService.listHoldingWorkOrders,
  queryKey: [...partReservationsBaseKey, "work-orders"] as const,
})
